class BurgerMenu extends HTMLElement {

  connectedCallback() {
    const button = this.querySelector('#burgerMenuToggle');
    const menu = this.querySelector('#burgerMenuWrapper');

    button.addEventListener('click', () => {
      menu.classList.toggle('open');
      button.classList.toggle('active');
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        menu.classList.remove('open');
        button.classList.remove('active');
      }
    });
  }
}

customElements.define('burger-menu', BurgerMenu);